import PatrolRoutesTable from '@/app/patrol-routes'
import { ability } from '@/casl/ability'
import TableSkeleton from '@/components/table-skeleton'
import { getFirstAccessibleRoute } from '@/constants/Auth'
import { routesByCompanyIdQueryOptions } from '@/hooks/useRoutesQuery'
import LocalStorage from '@/utilities/LocalStorage'
import { createFileRoute, redirect } from '@tanstack/react-router'

const RouteComponent = () => {
  return <PatrolRoutesTable />
}

export const Route = createFileRoute('/_auth/_withProject/patrol-routes')({
  beforeLoad: ({ context }) => {
    if (
      ability &&
      context.auth.user &&
      !ability.can('read', 'Devriye Rotaları')
    ) {
      // toast.error("Bu sayfayı görüntüleme izniniz yok.")
      const permissions = context.auth.user.permissions || []
      const redirectPath = getFirstAccessibleRoute(permissions)
      throw redirect({
        to: redirectPath,
      })
    }
  },
  loader: async ({ context }) => {
    const { queryClient } = context
    const companyId = LocalStorage.selectedCompany()?.id

    await queryClient.prefetchQuery(routesByCompanyIdQueryOptions(companyId))
    return {}
  },
  pendingComponent: TableSkeleton,
  component: RouteComponent,
})


